// src/utils/authUtils.js

/**
 * Check if user is authenticated by verifying auth_token exists
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem('auth_token');
  return !!token; // Returns true if token exists, false otherwise
};

/**
 * Get the auth token from localStorage
 */
export const getAuthToken = () => {
  return localStorage.getItem('auth_token');
};

/**
 * Set the auth token in localStorage
 */
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem('auth_token', token);
  }
};

/**
 * Remove the auth token from localStorage (logout)
 */
export const removeAuthToken = () => {
  localStorage.removeItem('auth_token');
};

/**
 * Check if token is valid (you can add expiry logic here)
 */
export const isTokenValid = () => {
  const token = getAuthToken();
  
  if (!token) {
    return false;
  }

  // Add your token validation logic here
  // For example, check expiry time if stored
  // const tokenData = JSON.parse(atob(token.split('.')[1]));
  // return tokenData.exp > Date.now() / 1000;
  
  return true;
};